import React, { useEffect, useState } from 'react';
import { Play } from 'lucide-react';

function initialValues(tool) {
  const values = {};
  (tool?.params || []).forEach((param) => {
    if (param.default !== null && param.default !== undefined) {
      values[param.name] = param.type === 'boolean' ? Boolean(param.default) : param.default;
    } else {
      values[param.name] = param.type === 'boolean' ? false : '';
    }
  });
  return values;
}

export default function McpToolForm({ tool, running, onRun }) {
  const [values, setValues] = useState(() => initialValues(tool));

  useEffect(() => {
    setValues(initialValues(tool));
  }, [tool]);

  const setValue = (name, value) => setValues((prev) => ({ ...prev, [name]: value }));

  const missingRequired = (tool?.params || []).some(
    (p) => p.required && p.type !== 'boolean' && String(values[p.name] ?? '').trim() === '',
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (missingRequired || running || tool.invokable === false) return;
    onRun?.(values);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-3">
        {(tool?.params || []).map((param) => (
          <div className="col-12 col-md-6" key={param.name}>
            <label className="form-label mb-1 d-flex align-items-center gap-1" htmlFor={`pf-${param.name}`}>
              <code className="small">{param.name}</code>
              {param.required ? <span className="text-danger">*</span> : null}
              <span className="badge bg-light text-muted border ms-1">{param.in}</span>
            </label>
            {param.type === 'boolean' ? (
              <div className="form-check form-switch">
                <input
                  id={`pf-${param.name}`}
                  type="checkbox"
                  className="form-check-input"
                  checked={Boolean(values[param.name])}
                  onChange={(e) => setValue(param.name, e.target.checked)}
                />
              </div>
            ) : (
              <input
                id={`pf-${param.name}`}
                type={param.type === 'integer' ? 'number' : 'text'}
                className="form-control"
                value={values[param.name] ?? ''}
                onChange={(e) => setValue(param.name, e.target.value)}
                placeholder={param.type === 'array' ? 'comma,separated,values' : ''}
              />
            )}
            {param.help ? <div className="form-text">{param.help}</div> : null}
          </div>
        ))}
        {(tool?.params || []).length === 0 ? (
          <div className="col-12 text-muted small">This tool takes no parameters.</div>
        ) : null}
      </div>
      <div className="mt-3 d-flex align-items-center gap-2">
        <button
          type="submit"
          className={`btn d-flex align-items-center gap-1 ${tool.danger ? 'btn-danger' : 'btn-primary'}`}
          disabled={missingRequired || running || tool.invokable === false}
        >
          <Play size={15} />
          {running ? 'Running…' : 'Run tool'}
        </button>
        {tool.invokable === false ? (
          <span className="small text-muted">{tool.invoke_note || 'Not runnable from the playground.'}</span>
        ) : null}
      </div>
    </form>
  );
}
